/**
 * CUIT/CUIL validation (mod-11 checksum, standard AFIP algorithm).
 * Intentional copy of the API util (same convention as the invoice-pdf
 * builders shared between admin and POS).
 */

const CUIT_WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

/**
 * Normalizes a CUIT: strips every non-digit character, requires exactly 11
 * digits and a valid mod-11 check digit. Returns the normalized 11-digit
 * string, or null when the input is not a valid CUIT.
 */
export function normalizeCuit(input: string): string | null {
  if (typeof input !== 'string') return null;

  const digits = input.replace(/\D/g, '');
  if (digits.length !== 11) return null;

  const sum = CUIT_WEIGHTS.reduce(
    (acc, weight, i) => acc + weight * Number(digits[i]),
    0
  );

  let expected = 11 - (sum % 11);
  if (expected === 11) expected = 0;
  // A remainder of 10 has no valid check digit: AFIP never assigns such CUITs.
  if (expected === 10) return null;

  return expected === Number(digits[10]) ? digits : null;
}
